<template>
  <div>
    <div v-if="dataLoading" class="row align-items-center ">
      <div class="col-12 text-center">
        <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
        ></v-progress-circular>
      </div>
    </div>
    <div v-else-if="items.length > 0 && items !== undefined" class="row">
      <div v-for="(item,i) in items" :key="i" class="col-12  py-2">
        <div class="row mx-2">
          <div class="col-3 p-0 pl-0">
            <v-img :src="$replaceHttps(item.FileUrl)" class="rounded-lg" aspect-ratio="1">
            </v-img>
          </div>
          <div class="col-9 py-0  d-flex flex-column pl-0">
            <div class="text-truncate mb-auto font-weight-bold primary-text">{{ item.Name }}</div>
            <div>
              <span  class="font12px third-text" >{{ $convertDate(item.ModifiedDate) }}</span> <router-link :to="{path:'ContentsDetail',query:{ExtraExtensionID:item.ExtraExtensionID}}"  class="float-left">ادامه
                    <i class="fa-solid fa-arrow-left mx-1 pointer"></i>
            </router-link>
            </div>
          </div>
        </div>


      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "ContentsList",
  props: ['dataLoading', 'items'],
  mounted() {
  }
}
</script>

<style scoped>

</style>
